module.exports = __webpack_public_path__ + "img/xpu-ha-room-4.153a51d3.jpg";